import { connect, ConnectedProps } from "react-redux";

import { IStoreState } from "../../../../../../reducers/types";
import { actions } from "../../../../actions";
import {
  getFromDate,
  getUntilDate,
  getLocation,
  getAdultsCount,
  getRoomsCount,
  getChildren,
  getPetsCount,
} from "../../../../reducer";
import { MobileCalendarPicker } from "./component";
import { actions as availabilityActions } from "../../../../../availability/actions";

const mapDispatchToProps = {
  setFromDate: actions.setFromDate,
  setUntilDate: actions.setUntilDate,
  setStayTypeFilter: availabilityActions.setStayTypeFilter,
};
const mapStateToProps = (state: IStoreState) => {
  return {
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    location: getLocation(state),
    adultsCount: getAdultsCount(state),
    children: getChildren(state),
    roomsCount: getRoomsCount(state),
    petsCount: getPetsCount(state),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileCalendarPickerConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileCalendarPicker = connector(MobileCalendarPicker);
